import React, { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import axios from "axiosClient";
import { Formik, Form, Field } from "formik";

import { Colxx } from "../components/common/CustomBootstrap";
import UserLayout from "layout/UserLayout";
import { useToken } from "auth/useToken";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "components/LanguageDropdown";

const Login = ({ loading }) => {
  const navigate = useNavigate();
  const [token, setToken] = useToken();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    date: "",
    server: "",
  });

  const onUserLogin = async (e) => {
    e.preventDefault();
    if (!loading) {
      if (email === "") {
        setErrors({ ...errors, email: t("enterEmail") });
      } else if (password === "") {
        setErrors({ ...errors, password: t("enterPassword") });
      } else if (password.length < 6) {
        setErrors({
          ...errors,
          password: t("atLeast6"),
        });
      } else if (email !== "" && password !== "") {
        try {
          const response = await axios.post("/api/login", {
            email,
            password,
          });
          setToken(response.data);
          navigate("/home");
        } catch (error) {
          // console.log(error.response);
          setErrors({ ...errors, server: error.response.data });
        }
      }
    }
  };

  return (
    <UserLayout>
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">Mock TKT</p>
              <p className="white mb-0">{t("loginText")}.</p>
            </div>
            <div className="form-side">
              <div className="d-flex align-items-center justify-content-between">
                <div></div>
                <LanguageDropdown />
              </div>
              <CardTitle className="mb-4">{t("login")}</CardTitle>

              <Formik>
                {() => (
                  <Form
                    className="av-tooltip tooltip-label-bottom"
                    onSubmit={onUserLogin}
                  >
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("email")}</Label>
                      <Field
                        className="form-control"
                        name="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrors({ ...errors, server: "", email: "" });
                        }}
                      />
                      {errors.email !== "" && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("password")}</Label>
                      <Field
                        className="form-control"
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setErrors({ ...errors, server: "", password: "" });
                        }}
                      />
                      {errors.password !== "" && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <p className="text-danger">{errors.server}</p>

                    <div className="d-flex justify-content-between align-items-center">
                      <NavLink to="/forgot-password">
                        {t("forgotPassword")}?
                      </NavLink>
                      <Button
                        type="submit"
                        color="primary"
                        className={`btn-shadow btn-multiple-state ${
                          loading ? "show-spinner" : ""
                        }`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">{t("login")}</span>
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>
      </Row>
    </UserLayout>
  );
};

export default Login;
